<template>
    <div class="accords">
      <div class="heading1 !mb-2">
        European Quantum Ecosystem
        <hr class="gradientLine" />
      </div>
      <div class="grid-cols-1 grid k1:grid-cols-2 gap-8 py-10">
      <div>
        <p>
            Ecosystem Impact: Building a Collaborative Quantum Future
        </p>
        <br />
        <p>
            The Accords Programme is more than a platform—it's a movement to unite Europe's quantum community and drive meaningful progress.
            By focusing on three key target groups, we aim to foster a thriving ecosystem that supports innovation, adoption, and collaboration.
        </p>
      </div>
      <img
        src="/EQRC logo full black.svg"
        alt=""
        class="w-[510px] object-cover"
      />
    </div>
    <div class="heading1 !mb-2">Our target groups</div>
    <div class="k1:flex-row flex flex-col-reverse gap-8 py-10">
      <div class="k1:w-[480px] w-full h-full flex-shrink-0">
        <img
          src="/stakeholders.png"
          alt=""
          class="object-cover w-full h-auto rounded-xl"
        />
      </div>
      <div class="flex-shrink-1">
        <p>
            <b>Educational institutions</b><br>
            Empowering the future workforce through innovative quantum education resources and training programs.
        </p>
        <br />
        <p>
            <b>Ecosystem builders</b><br>
            Uniting diverse actors to establish a resilient and inclusive quantum ecosystem across Europe.
        </p>
        <br />
        <p>
            <b>Companies</b><br>
            Driving industry leadership by fostering strategic readiness and collaboration for quantum integration.
        </p>
      </div>
    </div>
    <div class="flex flex-col gap-8 py-12">
        <h1 class="heading1 !mb-2 nowrap-computer">Driving Change: How We Impact the Ecosystem</h1>
            <p class="text-lg">1.Assembling Best Practices from First Movers</p>
            <ul class="list-disc pl-10">
                    <li>We identify and compile insights from early adopters of quantum technologies across Europe.</li>
                    <li>These best practices serve as a blueprint for others, helping accelerate innovation and adoption.</li>
                    <li>By showcasing the successes and lessons of pioneers, we inspire more organizations to take action.</li>
                </ul>
                <p class="text-lg">2.Reward Systems for Ecosystem Adoption</p>
                <ul class="list-disc pl-10">
                    <li>The Quantum Medal recognizes outstanding contributions to the ecosystem, encouraging participation and commitment.</li>
                    <li>Participating organizations receive visibility and credibility as leaders in the quantum space.</li>
                    <li>Rewards are tied to measurable impacts, fostering accountability and a results-driven culture.</li>
                </ul>

    </div>
    <img
          src="/RoadmapEQE.png"
          alt=""
          class="object-cover w-full h-auto w-[75%]"
        />
    <div class="flex flex-col gap-8 py-10">
    <h1 class="heading1 !mb-2">Are you ready to contribute to Europe's quantum future? </h1>
    <p>Take the first step by <RouterLink to="submitAccord" class="text-blue-500 underline hover:bg-blue-100">submitting your accord today!</RouterLink> </p>
    </div>    
    </div>
  </template>
  
  <script>
  </script>
  
  <style scoped>
  @media (min-width: 1024px) {
   .nowrap-computer {
    white-space: nowrap;
    }
  }
  </style>
  
  